import React from "react";
import "../assets/css/Accounts.css";
import "../assets/css/DigixLeads.css";
import AccountsLeadsPage from "./AccountsLeadsPage";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";

function Accounts({ accounts = [], customers = [], onAddAccountClick, onViewAccount, onEditAccount, onDeleteAccount }) {
  const role = (() => {
    try {
      const u = localStorage.getItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  })();
  const canAdd = canPerformActionOnPage(PAGES.ACCOUNTS, ACTIONS.ADD, role);
  const canEdit = canPerformActionOnPage(PAGES.ACCOUNTS, ACTIONS.EDIT, role);
  const canDelete = canPerformActionOnPage(PAGES.ACCOUNTS, ACTIONS.DELETE, role);
  return (
    <div className="accounts-container">
      <div className="main-card">
        <AccountsLeadsPage
          accounts={accounts}
          customers={customers}
          rowsPerPage={5}
          onViewAccount={onViewAccount}
          onEditAccount={canEdit ? onEditAccount : undefined}
          onDeleteAccount={canDelete ? onDeleteAccount : undefined}
          onAddAccountClick={canAdd ? onAddAccountClick : undefined}
        />
      </div>
    </div>
  );
}

export default Accounts;
